const defaultChildSelection = {
	empty: true,
	id: false,
	gender: false,
	age: false,
}

export default defaultChildSelection